// Abstract "Signal" brand motif — concentric signal rings radiating from a center node.
// Replaces the legacy LogoX as the decorative mark (profile banner + sign-up auth hero):
// reads as a broadcast/pulse, fits the "Signal Glass" identity + the platform's Spread-It
// theme, and is unmistakably NOT an X. Drawn with currentColor so each context controls
// color/opacity (subtle on the banner, vivid + glowing on the auth hero). Orientation-agnostic
// concentric rings so it works as a corner watermark or a centered set-piece.
export function SignalMark({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      aria-hidden="true"
    >
      <circle cx="24" cy="24" r="4" fill="currentColor" stroke="none" />
      <circle cx="24" cy="24" r="10" opacity="0.85" />
      <circle cx="24" cy="24" r="16" opacity="0.5" />
      <circle cx="24" cy="24" r="22" opacity="0.28" />
    </svg>
  );
}
